import { OffsetPaginationMetaEntity } from "@/entities/OffsetPaginationEntity";

import { PaginationMeta } from "../types/PaginationMeta";

export const transformMeta = (
    meta: OffsetPaginationMetaEntity
): PaginationMeta => {
    return {
        limit: meta.perPage,
        offset: meta.currentOffset,
        total: meta.totalCount,
    };
};
